/* IB-7 v15 (Theme-Port 14.10.2026). Quelle design/prototyp/v15/v15-pdp.js. */
/* IB-7 Prototyp v15-pdp.js (Entwurf 14.10.2026, Runde v15). Vanilla JS, defer, nach ib7.js.
   Nur Perfect-Duo-Seite: Die Set-Auswahl (Duo, nur THE PULSE, nur THE AURA) aktualisiert Preis, Einzelpreis,
   Ersparnis, Grundpreis und Preis pro Anwendung im Kaufbereich und in der Kaufleiste.
   Shopify: Variantenwahl mit Section Rendering API, alle Werte aus Liquid (data-dynamic). */
(function () {
  'use strict';
  var start = function () {
    var radios = document.querySelectorAll('input[name="pick"][data-price]');
    if (radios.length < 2) return;
    var set = function (sel, txt) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); };
    var render = function (r) {
      set('[data-dynamic="price"]', r.getAttribute('data-price'));
      set('[data-dynamic="unit"]', r.getAttribute('data-unit'));
      set('[data-dynamic="per-use"]', r.getAttribute('data-per-use') + ' pro Anwendung¹');
      var was = r.getAttribute('data-was'), save = r.getAttribute('data-save');
      document.querySelectorAll('[data-dynamic="was"]').forEach(function (el) { el.hidden = !was; if (was) el.textContent = 'Einzeln ' + was; });
      document.querySelectorAll('[data-dynamic="save"]').forEach(function (el) { el.hidden = !save; if (save) el.textContent = 'Du sparst ' + save; });
    };
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) render(r); }); });
  };
  var done = false, once = function () { if (!done) { done = true; start(); } };
  if (document.readyState === 'complete') once();
  else { document.addEventListener('DOMContentLoaded', once); window.addEventListener('load', once); }
})();
